import * as React from 'react';

function SvgDownloadIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      {...props}>
      <path
        stroke="#007BFF"
        strokeLinecap="round"
        strokeWidth={1.75}
        d="M10 2.5V13"
      />
      <path
        stroke="#007BFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M5.75 9.25 10 13.5l4.25-4.25"
      />
      <path
        stroke="#007BFF"
        strokeLinecap="round"
        strokeWidth={1.75}
        d="M3 14.5v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2"
      />
    </svg>
  );
}
export default SvgDownloadIcon;
